module.exports = __webpack_public_path__ + "img/05@2x.40570a62.png";